/* eslint-disable no-param-reassign */

/**
 * @param key The original VariantKey.
 * @param overwriteKey A key containing overwrites. May contain *.
 *
 * Combines two Product Position Keys by overwriting the positions of the key with overwriteKey.
 * If a position is * or inexistent in the overwriteKey the original is kept.
 */
import { exists } from "shared/lib/exists"

import { produce } from "immer"

function combineVariantKeysInternal(
  key: string | null | undefined,
  overwriteKey: string | null | undefined
): string | null {
  if (!exists(key) && !exists(overwriteKey)) {
    return null
  }
  if (!exists(key)) {
    return overwriteKey || null
  }
  if (!exists(overwriteKey)) {
    return key
  }
  const positions = key.split("-")
  const overwrites = overwriteKey.split("-")

  return produce(positions, (array: string[]) => {
    overwrites.forEach((overwrite, index) => {
      if (overwrite && overwrite !== "*") {
        array[index] = overwrite
      }
    })
  }).join("-")
}

export function combineVariantKeys(...keys: string[]): string
export function combineVariantKeys(
  ...keys: (string | null | undefined)[]
): string | null
export function combineVariantKeys(
  ...keys: (string | null | undefined)[]
): string | null {
  return keys.reduce(combineVariantKeysInternal, null) as string | null
}
